import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Bell, CheckCheck } from "lucide-react";
import { api, timeAgo } from "@/lib/api";
import { EmptyState, Loading } from "@/components/EmptyState";
import { Button } from "@/components/ui/button";

export default function Notifications() {
  const navigate = useNavigate();
  const [notes, setNotes] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => { const { data } = await api.get("/notifications"); setNotes(data.notifications); setLoading(false); };
  useEffect(() => { load(); }, []);

  const readAll = async () => { await api.post("/notifications/read-all"); load(); };
  const open = async (n) => {
    if (!n.read) await api.post(`/notifications/${n.id}/read`);
    if (n.job_id) navigate(`/pekerjaan/${n.job_id}`); else load();
  };

  if (loading) return <Loading />;
  return (
    <div data-testid="notifications">
      <div className="flex items-center justify-between mb-5">
        <h1 className="text-2xl sm:text-3xl font-extrabold">Notifikasi</h1>
        {notes.some((n) => !n.read) && (
          <Button data-testid="read-all-btn" variant="ghost" onClick={readAll} className="text-blue-600 font-semibold"><CheckCheck size={16} className="mr-1" /> Tandai semua</Button>
        )}
      </div>
      {notes.length === 0 ? (
        <EmptyState icon={Bell} title="Belum ada notifikasi" description="Notifikasi lamaran, chat, dan rating akan muncul di sini." />
      ) : (
        <div className="space-y-2">
          {notes.map((n) => (
            <div key={n.id} data-testid={`notif-${n.id}`} onClick={() => open(n)}
              className={`rounded-xl border p-4 flex items-start gap-3 cursor-pointer transition-colors ${n.read ? "bg-white border-slate-200" : "bg-blue-50 border-blue-200"}`}>
              <div className={`w-9 h-9 rounded-full flex items-center justify-center shrink-0 ${n.read ? "bg-slate-100 text-slate-400" : "bg-blue-600 text-white"}`}><Bell size={16} /></div>
              <div className="min-w-0 flex-1">
                <p className="text-slate-800 text-sm">{n.message}</p>
                <p className="text-xs text-slate-400 mt-0.5">{timeAgo(n.created_at)}</p>
              </div>
              {!n.read && <span className="w-2 h-2 rounded-full bg-blue-600 mt-2 shrink-0" />}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
